import { render, staticRenderFns } from "./PageSpecificFaqUrls.vue?vue&type=template&id=36d17ee8"
import script from "./PageSpecificFaqUrls.vue?vue&type=script&lang=ts"
export * from "./PageSpecificFaqUrls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports